import { useEffect } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { Box, Flex } from "@chakra-ui/react";
import DsrPostTextAreaInput from '../../forms/TextareaField/components/DsrPostTextAreaInput';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';
import { TbMessage2Question } from 'react-icons/tb';


function CreateNewFaqQuestionModal({
  dsrId,
  userActionRequired,
  handleCloseModal,
  showDsrModalLoader,
  // Redux
  manageFaqProcessingCompleted,
  isRoomTemplate
}) {

  useEffect(() => {
    if (manageFaqProcessingCompleted === true) {
      handleCloseModal()
    }

  }, [manageFaqProcessingCompleted]);

  const subTextCopyContent = isRoomTemplate ? "Rooms created with this template shall include this question going forward."
    : "Help your audience understand common issues more quickly"

  // From FAQ page
  return (
    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={TbMessage2Question} color='white' boxSize="1em" />
        <Box color='white'>Prepare a question</Box>
      </Flex>}
      handleCloseModal={handleCloseModal}
      showModal={true}
      maxW='35em'
    >

      <Box w='100%' py='1em' color='gray.500' fontSize='0.875em' lineHeight='1.25em' borderBottom='1px solid' borderBottomColor='gray.100'>
        <Flex w='100%' px='2em' justify='flex-start' color='brandDark.500'>{subTextCopyContent}</Flex>
      </Box>

      {showDsrModalLoader === true ? <PageLoader /> :
        <Flex justify='center' w='100%'>
          <Box w="100%" align="center">
            <DsrPostTextAreaInput
              dsrId={dsrId}
              userActionRequired={userActionRequired}
              name="prepareDsrPostQuestion"
              placeholder='Type your question here'
              fontSize='1em'
              htmlFor="prepareDsrPostQuestion"
            />
          </Box>
        </Flex>
      }
    </LaunchdeckModal>
  )
}

const mapStateToProps = (state) => ({
  manageFaqProcessingCompleted: state.manageDsrFaqContentOutcome?.results?.processingCompleted,
  isRoomTemplate: state.dsrTemplateId.isRoomTemplate,
})


export default withRouter(connect(mapStateToProps, null)(CreateNewFaqQuestionModal))
